var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return (() => _vm.updateRecord()).apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-2 form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Проект")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newRecord.project_id,
                        expression: "newRecord.project_id",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.newRecord,
                          "project_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.$AllProjects, function (p) {
                    return p.is_active
                      ? _c("option", { domProps: { value: p.id } }, [
                          _vm._v(_vm._s(p.title)),
                        ])
                      : _vm._e()
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-5 form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Линк")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newRecord.url,
                      expression: "newRecord.url",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", required: "" },
                  domProps: { value: _vm.newRecord.url },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.newRecord, "url", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c("LoadingButton", {
                  attrs: {
                    title: "Сохранить",
                    loading: _vm.loading.saveNew,
                    type: "submit",
                    color: _vm.$constants.SUCCESS_COLOR,
                    onClick: () => {},
                    className: "btn btn-outline-success",
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.topPriorityRecords.length
      ? _c("div", { staticClass: "card" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-sm table-hover" }, [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.topPriorityRecords, function (r, i) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(i + 1))]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(
                          _vm.$AllProjects[r.project_id]?.title ?? r.project_id
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("a", { attrs: { target: "_blank", href: r.url } }, [
                        _vm._v(_vm._s(r.url)),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loading.list || _vm.records
      ? _c("div", { staticClass: "card" }, [
          _vm._m(3),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.project_id,
                      expression: "filter.project_id",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.filter,
                          "project_id",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function ($event) {
                        return _vm.getRecords()
                      },
                    ],
                  },
                },
                [
                  _c("option", { attrs: { value: "0" } }, [
                    _vm._v("Все проекты"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.$AllProjects, function (p) {
                    return p.is_active
                      ? _c("option", { domProps: { value: p.id } }, [
                          _vm._v(_vm._s(p.title)),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loading.list,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
              _vm._v(" "),
              _vm.records
                ? [
                    _c("hr"),
                    _vm._v(" "),
                    _c(
                      "table",
                      { staticClass: "table mt-0 table-sm table-hover" },
                      [
                        _vm._m(4),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.records, function (r, i) {
                            return _c("tr", [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    i +
                                      1 +
                                      (_vm.paginator.current_page - 1) *
                                        _vm.paginator.per_page
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(r.project_web_site?.drug_id)),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    r.project_id
                                      ? _vm.$AllProjects[r.project_id]?.title ??
                                          r.project_id
                                      : r.project_id
                                  ) + "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                r.project_web_site?.url
                                  ? _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: r.project_web_site.url,
                                          target: "_blank",
                                        },
                                      },
                                      [_vm._v(_vm._s(r.project_web_site.url))]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  class: {
                                    "font-weight-bold": _vm.isTextBold(
                                      r.issue_text
                                    ),
                                    "text-success": _vm.isTextBold(
                                      r.issue_text,
                                      "no_issue"
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(r.issue_text) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(r.issue_code))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.printDate(
                                      r.updated_at,
                                      "DD.MM.YYYY HH:mm"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.printDate(
                                      r.created_at,
                                      "DD.MM.YYYY HH:mm"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: r.sub_status,
                                      expression: "r.sub_status",
                                    },
                                  ],
                                  attrs: { type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(r.sub_status)
                                      ? _vm._i(r.sub_status, null) > -1
                                      : r.sub_status,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = r.sub_status,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              r,
                                              "sub_status",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              r,
                                              "sub_status",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(r, "sub_status", $$c)
                                      }
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _vm.getActivityTitle(r)
                                    ? _c("LoadingButton", {
                                        attrs: {
                                          title: _vm.getActivityTitle(r),
                                          loading:
                                            _vm.loading.updateActivity[r.id],
                                          type: "button",
                                          color: "#4fc47f",
                                          onClick: () =>
                                            _vm.updateRecordActivity(r),
                                          className:
                                            "btn btn-outline-success btn-xs",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: r.extra_data.comment,
                                      expression: "r.extra_data.comment",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "комментарий",
                                  },
                                  domProps: { value: r.extra_data.comment },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        r.extra_data,
                                        "comment",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("LoadingButton", {
                                    attrs: {
                                      title:
                                        '<i class="icon-fa icon-fa-save"></i>',
                                      loading: _vm.loading.updateRecord[r.id],
                                      type: "button",
                                      color: "#4fc47f",
                                      onClick: () => _vm.updateRecord(r),
                                      className:
                                        "btn btn-outline-success btn-xs",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _vm.paginator
                          ? _c("paginate", {
                              attrs: {
                                "page-count": _vm.paginator.last_page,
                                "page-range": 3,
                                "margin-pages": 2,
                                "click-handler": _vm.getRecords,
                                "prev-text": "&laquo",
                                "next-text": "&raquo",
                                "container-class": "pagination",
                                "prev-class": "page-item",
                                "prev-link-class": "page-link",
                                "page-class": "page-item",
                                "page-link-class": "page-link",
                                "next-class": "page-item",
                                "next-link-class": "page-link",
                                "active-class": "active green_btn",
                              },
                              model: {
                                value: _vm.paginator.current_page,
                                callback: function ($$v) {
                                  _vm.$set(_vm.paginator, "current_page", $$v)
                                },
                                expression: "paginator.current_page",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Добавление ссылки для приоритетного сканирования")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Ссылки для приоритетного сканирования")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Проект")]),
        _vm._v(" "),
        _c("th", [_vm._v("link")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Ссылки в реестре РКН")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("Проект")]),
        _vm._v(" "),
        _c("th", [_vm._v("link")]),
        _vm._v(" "),
        _c("th", [_vm._v("статус")]),
        _vm._v(" "),
        _c("th", [_vm._v("блокировка")]),
        _vm._v(" "),
        _c("th", [_vm._v("дата обновления")]),
        _vm._v(" "),
        _c("th", [_vm._v("дата внесения")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }